import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { CircleNotch, DownloadSimple } from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./Reveal";
import { useDownload } from "@/lib/download";

const MARQUEE_TEXT = "Your USDT to INR Exchange — Right in Your Pocket — ";

export default function AppPromo() {
  const { startDownload, downloading } = useDownload();

  return (
    <section id="app-download" data-testid="app-promo-section" className="relative border-t border-white/5 py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-x-0 top-10 select-none overflow-hidden" aria-hidden>
        <Marquee speed={22} gradient={false}>
          {Array.from({ length: 4 }).map((_, i) => (
            <span
              key={i}
              className="mx-4 whitespace-nowrap font-display text-6xl font-extrabold uppercase tracking-tighter text-white/[0.04] sm:text-8xl"
            >
              {MARQUEE_TEXT}
            </span>
          ))}
        </Marquee>
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 pt-16 sm:px-8 lg:grid-cols-12">
        <Reveal className="order-2 lg:order-1 lg:col-span-5">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-8 -z-10 rounded-full bg-[radial-gradient(circle,rgba(0,245,160,0.14),transparent_65%)] blur-2xl"
            />
            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut" }}
              className="mx-auto w-[270px] sm:w-[310px]"
              data-testid="app-promo-visual"
            >
              <div className="rounded-[2.8rem] border border-white/15 bg-[#0B1220] p-2.5 shadow-[0_50px_100px_rgba(0,0,0,0.6)]">
                <div className="relative overflow-hidden rounded-[2.2rem] border border-white/5 bg-[#050B14] px-6 pb-8 pt-12">
                  <div aria-hidden className="absolute left-1/2 top-3 h-5 w-24 -translate-x-1/2 rounded-full bg-black/80" />
                  <div className="flex justify-center">
                    <img
                      src="/assets/coin-adda-logo.png"
                      alt="Coin Adda"
                      className="h-9 w-auto"
                      data-testid="app-promo-screen-logo"
                    />
                  </div>
                  <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    Today's Exchange
                  </p>
                  <div className="mt-3 rounded-2xl border border-[#00F5A0]/25 bg-[#00F5A0]/5 px-5 py-4 text-center">
                    <p className="font-mono text-xl font-bold text-slate-50">
                      1 USDT <span className="text-slate-500">→</span> <span className="text-[#00F5A0]">₹ --.--</span>
                    </p>
                    <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500">
                      Live rate in app
                    </p>
                  </div>
                  <div className="mt-4 space-y-2.5">
                    <div className="flex items-center justify-between rounded-xl border border-white/10 px-4 py-3">
                      <span className="text-xs text-slate-400">Deposit</span>
                      <span className="font-mono text-xs font-medium text-slate-100">USDT</span>
                    </div>
                    <div className="flex items-center justify-between rounded-xl border border-white/10 px-4 py-3">
                      <span className="text-xs text-slate-400">Withdraw</span>
                      <span className="font-mono text-xs font-medium text-slate-100">INR · Bank</span>
                    </div>
                  </div>
                  <div className="mt-5 rounded-full bg-[#00F5A0] py-3 text-center text-xs font-bold text-[#050B14]">
                    Exchange Now
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2 lg:col-span-7">
          <ChapterTag index="04" label="Get the App" />
          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl lg:text-6xl">
            Your USDT to INR Exchange, <span className="text-[#00F5A0]">Right in Your Pocket</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 sm:text-lg">
            Download the Coin Adda app and start exchanging USDT to INR
            anytime. Deposit USDT, track your exchange and withdraw INR to
            your bank — all from one simple app.
          </p>

          <div className="mt-10">
            <button
              type="button"
              data-testid="app-promo-download-btn"
              onClick={startDownload}
              disabled={downloading}
              className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#00F5A0] px-10 py-5 text-lg font-bold text-[#050B14] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-[#00D68B] hover:shadow-[0_20px_60px_rgba(0,245,160,0.35)] disabled:opacity-70 sm:w-auto"
            >
              {downloading ? (
                <CircleNotch size={22} weight="bold" className="animate-spin" />
              ) : (
                <DownloadSimple size={22} weight="bold" />
              )}
              {downloading ? "Starting Download…" : "Download App"}
            </button>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="app-promo-note">
              Android APK · Free Download
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
